import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { loadDonorRecipients, deleteDonorRecipient } from '../../../../../redux/actions/donorRecipient.actions';
import { AdditionalSchoolYearOptions, SchoolYearOptionComponents, SPECIAL_LINK_SCHOOL_YEAR_IDENTIFIER } from '../../modals/DonorRecipientModal';
import { Spinner } from '@blueprintjs/core';

class DonorHeader extends Component {
    render() {
        return (
            <div className="panel-title">
                <span className="panel-title-flex">
                    <h4>Linked Recipients</h4>
                </span>
                <span className="panel-title-fixed">
                    <button type="button"
                        className="pt-button pt-small pt-intent-primary pt-icon-add"
                        onClick={(event) => this.props.openModal({ event })}>
                        Add Link
                    </button>
                </span>
            </div>
        );
    }
}

const EmptyView = props => {
    return (
        <div className="intro">
            <div className="intro-text">Click here to link a recipient to this donor. <span onClick={(event) => props.openModal({ event })} className="link">Add Link</span></div>
        </div>
    );
};

class LinkRecipientsDonor extends Component {
    componentDidMount() {
        this.loadData();
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.donorId !== this.props.donorId) {
            this.loadData(nextProps);
        }
    }
    loadData = async (props = this.props) => {
        const { donorId } = props;
        props.loadDonorRecipients(donorId);
    }
    openModal = ({ rowData, event }) => {
        event.preventDefault();
        event.stopPropagation();

        const { donorRecipients } = this.props.donorRecipientState;
        const { donorId } = this.props;

        const defaultFromData = { donorId, currentRecipients: donorRecipients.map(recipient => recipient.recipient_id) };
        const form = rowData ? { ...rowData, ...defaultFromData} : defaultFromData;

        const customEvent = new CustomEvent(('open-add-donor-recipient-modal'), { detail: form });
        window.dispatchEvent(customEvent);
    }

    deleteRow = ({ event, donorRecipient }) => {
        event.preventDefault();
        event.stopPropagation();
        const customEvent = new CustomEvent('open-delete-modal', {
            detail: {
                content: 'Are you sure you want to remove this linked recipient?',
                onDelete: () => {
                    this.props.deleteDonorRecipient({
                        donorId: this.props.donorId,
                        recipientId: donorRecipient.recipient_id,
                        donorRecipientLinkId: donorRecipient.id,
                    });
                }
            }
        });
        window.dispatchEvent(customEvent);
    }

    sendEmailUpdate = ({ event, donorRecipient }) => {
        event.preventDefault();
        event.stopPropagation();

        const customEvent = new CustomEvent('open-send-donor-recipient-progress-update-modal', {
            detail: {
                donorId: donorRecipient.donor_id,
                recipient_id: donorRecipient.recipient_id,
                donorRecipientLinkId: donorRecipient.id,
            }
        });
        window.dispatchEvent(customEvent);
    }

    getLinkYearDisplayValue = (backendAPIReturnedYear, link_type) => {
        const ongoingLink = SPECIAL_LINK_SCHOOL_YEAR_IDENTIFIER[AdditionalSchoolYearOptions.ONGOING];
        const unknownLink = SPECIAL_LINK_SCHOOL_YEAR_IDENTIFIER[AdditionalSchoolYearOptions.UNKNOWN];
        if (link_type === "link_end_school_year" && backendAPIReturnedYear === ongoingLink[SchoolYearOptionComponents.BACKEND_VALUE]) {
            return ongoingLink[SchoolYearOptionComponents.DISPLAY_VALUE];
        }
        if (link_type === "link_start_school_year" && backendAPIReturnedYear === unknownLink[SchoolYearOptionComponents.BACKEND_VALUE]) {
            return unknownLink[SchoolYearOptionComponents.DISPLAY_VALUE];
        }
        return backendAPIReturnedYear;
    }

    render() {
        const { donorRecipients, allLoading } = this.props.donorRecipientState;
        return (
            <Fragment>
                <DonorHeader openModal={this.openModal} />
                <div className="panel-donation panel-content">
                    { allLoading ? 
                        <div className="spinner-container">
                            <Spinner large />
                        </div> :
                        donorRecipients.length === 0 ?
                            <EmptyView openModal={this.openModal} /> :
                            <table className="general-table pt-html-table pt-interactive">
                                <thead>
                                    <tr>
                                        <th>Recipient</th>
                                        <th>School year link started</th>
                                        <th>School year link ended</th>
                                        <th>Notes</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { donorRecipients.map((donorRecipient, i) => {
                                        return (
                                            <tr key={i} onClick={(event) => this.openModal({ rowData: donorRecipient, event })}>
                                                <td>{donorRecipient.recipient_name}</td>
                                                <td>{this.getLinkYearDisplayValue(donorRecipient.link_start_school_year, "link_start_school_year")}</td>
                                                <td>{this.getLinkYearDisplayValue(donorRecipient.link_end_school_year, "link_end_school_year")}</td>
                                                <td>{donorRecipient.notes}</td>
                                                <td className="action-row">
                                                    <div className="pt-button pt-intent-primary pt-icon-envelope pt-small" onClick={(event) => this.sendEmailUpdate({ donorRecipient, event})}>Email Update</div>
                                                    <div className="pt-button pt-intent-danger pt-icon-trash pt-small" onClick={(event) => this.deleteRow({ donorRecipient, event})}>Delete</div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                    }
                </div>
            </Fragment>
        );
    }
}


const mapStateToProps = (state) => ({
    donorRecipientState: state.donorRecipient,
});

export default withRouter(connect(
    mapStateToProps,
    { loadDonorRecipients, deleteDonorRecipient }
)(LinkRecipientsDonor));


// WEBPACK FOOTER //
// ./src/components/main/dashboard/panel/donor/LinkRecipientsDonor.jsx